module.exports = __webpack_public_path__ + "static/img/youtube_ewm.cd101fc4.png";